// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"24f9e501","574":"24f9e501","779":"a3a70a96","994":"24f9e501"}[chunkId] + ".chunk.css";
};